<template>
  <div class="data-big-screen">
    <a-button type="primary" class="skip-btn" @click="getSkipUrl">立即进入</a-button>
  </div>
</template>
<script>
import { getAction } from '@api/manage'
import Vue from 'vue'
import { TENANT_ID } from '@/store/mutation-types'

export default {
  name: 'DataBigScreenSkip',
  data() {
    return {
      url: '',
    }
  },
  methods: {
    async getSkipUrl() {
      let tenantId = Vue.ls.get(TENANT_ID)
      const res = await getAction('/statisticEducation/getSchoolScreenUrl', { tenantId })
      if (res.success) {
        this.url = res.result.url
        console.log('this.url', res.result.url)
        window.open(this.url, '_blank')
      }
    },
  },
}
</script>

<style scoped lang="less">
.data-big-screen {
  position: relative;
  width: 96vw;
  height: calc(100vh - 80px);
  background: url('~@/assets/schoolDataScreenbg.png') no-repeat center center;
  background-size: cover;

  .skip-btn {
    position: absolute;
    top: 50%;
    left: 130px;
    width: 200px;
    height: 42px;
    font-size: 16px;
  }
}
</style>
